import {AlpineComponent} from 'alpinejs';

type Timeline = {}

export default (): AlpineComponent<Timeline> => ({
  init() {
    // Prevent bad scrollbar height calculation after refresh if scrolled
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    };

    // Progress bar
    const progressBarObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const progressContainer = entry.target.querySelector<HTMLElement>('.ce-timeline-progress');
          const progressBar = entry.target.querySelector<HTMLElement>('.ce-timeline-progress');
          if (!progressContainer || !progressBar) {
            return;
          }
          const screenWidth = window.innerWidth;
          let scrollTopMultiplier = 0;
          let scrollPositionStart = 0;
          let scrollPositionStartMultiplier = 0;

          const updateProgressBarHeight = () => {
            // Calculate scroll value
            scrollTopMultiplier = 50;
            scrollPositionStart = 5;
            scrollPositionStartMultiplier = -21;

            let scrollTop = window.pageYOffset - (entry.boundingClientRect.top - scrollTopMultiplier);
            if (scrollTop <= 0) {
              scrollTop = 0;
            }

            // Calculate scroll bar height
            const scrollPosition = ((scrollTop / progressContainer.clientHeight) * 100) + scrollPositionStartMultiplier;
            if (scrollPosition >= scrollPositionStart && scrollPosition <= 100) {
              progressBar.style.background = `linear-gradient(180deg, rgba(0,224,255,1) 0%, rgba(0,244,255,${scrollPosition / 100}0) 100%)`;
            }
          };

          window.addEventListener('scroll', updateProgressBarHeight);
          updateProgressBarHeight();
          observer.unobserve(entry.target);
        }
      });
    }, {rootMargin: '-100% 0px 0px 0px', threshold: 0});
    const elements = document.querySelectorAll('.ce-timeline');
    elements.forEach((element) => {
      progressBarObserver.observe(element);
    });

    // Item hover
    const itemObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        } else {
          entry.target.classList.remove('active');
        }
      });
    }, {rootMargin: '-50% 0%'});
    document.querySelectorAll('.ce-timeline-item').forEach((element) => {
      itemObserver.observe(element);
    });
  }
});
